<template>
  <b-card :title="cardTitle">
    <template slot="body">
      <div class="card-body p-0">

          <b-tabs
            nav-id="dougnat-card-tabs"
            tabs-id="dougnat-card-tabs-content"
            :data-loading="dataLoading">

            <b-tab label="Chart" id="data-tab-chart">
              <dougnat-chart ref="chart" :chart-data="displayedData"></dougnat-chart>
              
                <button class="btn btn-sm btn-primary border border-dark float-right" @click="$refs.chart.exportToImg()" >PNG</button>

            </b-tab>

            <b-tab label="Table" id="data-tab-table">

              <dougnat-table ref="table" :table-data="displayedData"></dougnat-table>
              <button class="btn btn-sm btn-primary border border-dark float-right" @click="$refs.table.exportTableToCSV()" > CSV </button>

            </b-tab>

          </b-tabs>

          <div class="query-controls pl-3 pr-3 pb-3">
            <slot :query-params="queryParams">
            </slot>
            <button @click="onGetData" class="btn btn-primary border border-dark"> Get Data </button>
          </div>

      </div>
    </template>
  </b-card>
</template>

<script>
import BTabs from '../common/BootstrapTabs';
import BTab from '../common/BootstrapTab';
import DoughnatChart from './DoughnatChartComponent';
import DoughnatTable from './DoughnatChartTableComponent';
import ChartCard from '../mixins/ChartCardMixin';

export default {
    components: {
        'b-tabs': BTabs,
        'b-tab': BTab,
        'dougnat-chart': DoughnatChart,
        'dougnat-table': DoughnatTable,
    },

    mixins: [
        ChartCard,
    ],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/DoughnatChartCardComponent.vue